var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlowBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2146,
    height: 744,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "43.176%",
    x2: "50%",
    y1: "12.436%",
    y2: "97.744%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A855F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6366F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "19.609%",
    x2: "50%",
    y1: "14.544%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6366F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "145.2%",
    height: "187%",
    x: "-22.6%",
    y: "-43.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 50
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: "165.1%",
    height: "170.3%",
    x: "-32.5%",
    y: "-35.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 50
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: "50%",
    cy: "100%",
    r: "77.678%",
    fx: "50%",
    fy: "100%",
    gradientTransform: "matrix(0 -1 .37746 0 .123 1.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E9D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.35%",
    stopColor: "#A855F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0F172A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h2440v921H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-140 -177)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M0 0h2440v921H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "nonzero",
    d: "M1975.72 781.763c-3.682-3-8.757-3.61-13.042-1.568a12.323 12.323 0 0 0-7.014 11.129v98.57h-430.368c-6.79 0-12.296 5.516-12.296 12.321v98.57c0 6.805 5.505 12.321 12.296 12.321h430.368v98.57a12.323 12.323 0 0 0 7.014 11.129 12.276 12.276 0 0 0 13.042-1.568l196.74-160.176a12.33 12.33 0 0 0 4.54-9.561 12.33 12.33 0 0 0-4.54-9.561l-196.74-160.176Z",
    filter: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m913 274 461 369-284 58z",
    filter: "url(#g)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowBottom);
export default __webpack_public_path__ + "static/media/glow-bottom.4e33c54001acd711feffc5ddcc9179d6.svg";
export { ForwardRef as ReactComponent };